const filterMonthlyBidding = (data, limit = 15) => {
  const uniquePortals = [...new Set(data.map(item => item.portal))]

  const portalCounts = uniquePortals.map(portal => ({
    label: portal,
    value: data.filter(item => item.portal === portal).length,
  }))

  const sortedPortals = portalCounts
    .sort((a, b) => b.value - a.value)
    .slice(0, limit)

  // Definir as cores de fundo para cada fase
  const backgroundColor = sortedPortals.map((_, index) => (
    index === 0 ? '#28a745' : '#005C96'
  ))

  return {
    labels: sortedPortals.map(item => (item.label.length > 16 ? `${item.label.slice(0, 13)}...` : item.label)),
    datasets: [{
      label: 'Licitações por portal mensal',
      data: sortedPortals.map(item => item.value),
      backgroundColor,
    }],
  }
}

export default filterMonthlyBidding
